import React from 'react';
import {
  IconMapMetroMsk16,
  IconMapMetroSpb16,
  IconMapMetroSam16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
} from '@cian/ui-kit-design-tokens/icons';

export enum UndergroundType {
  /** Москва */
  Msk = 'mow',
  /** Санкт-Петербург */
  Spb = 'spb',
  /** Самара */
  Samara = 'smr',
  /** Екатеринбург */
  Ekb = 'ekb',
  /** Казань */
  Kazan = 'kzn',
  /** Нижний новгород */
  Nizhniy = 'nn',
  /** Новосибирск */
  Novosib = 'nsk',
}

export interface IMetroIconParams {
  type?: UndergroundType;
}

/**
 * Региональная иконка метро
 */
export const UndergroundIcon = ({ type }: IMetroIconParams) => {
  switch (type) {
    case UndergroundType.Msk:
      return <IconMapMetroMsk16 />;

    case UndergroundType.Spb:
      return <IconMapMetroSpb16 />;

    case UndergroundType.Samara:
      return <IconMapMetroSam16 />;

    case UndergroundType.Ekb:
      return <IconMapMetroEkb16 />;

    case UndergroundType.Kazan:
      return <IconMapMetroKzn16 />;

    case UndergroundType.Nizhniy:
      return <IconMapMetroNN16 />;

    case UndergroundType.Novosib:
      return <IconMapMetroNovosib16 />;

    default:
      return <IconMapMetroMsk16 />;
  }
};
